import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  DatePicker,
  Table,
  message,
  Popconfirm,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import "./TenderAdd.css";
import { API } from "../../../API/API";
import UserContext from "../../UserContext/UserContext";

const dateFormat = "YYYY.MM.DD";
var moment = require("moment");
let dynamickey = 1;

class TenderAdd extends Component {
  static contextType = UserContext;

  formRef = React.createRef();
  constructor(props){ 
    super(props) 
    this.state = {
        purchasetypelist: [],
        tendertypelist: [],
        deplist: [],
        batch: [],
        tenderid: this.props.tenderid,
        tendercode: "",
        tendername: "",
        tendertypeid: null,
        purchasetypeid: null,
        departmentid: null,
        budget: null,
        evaluationdate: null,
        publishdate: null,
        startdate: null,
        enddate: null,
        plandate: null,
        isEdit: this.props.isEdit,
        dkey: 1,
        error: null
    };
    this.handleInputChange = this.handleInputChange.bind(this) 
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.onChangeBatchCode = this.onChangeBatchCode.bind(this)
    this.onChangeBatchName = this.onChangeBatchName.bind(this)
    this.addBatch = this.addBatch.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.onSave = this.onSave.bind(this) 
  } 
  
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    let tenderid = this.state.tenderid;
    API.get("/getTenderInitialData?tenderid=" + tenderid).then((response) => {
      if (response.status === 200) {
        this.setState({
          tendertypelist: response.data.retData[0],
          purchasetypelist: response.data.retData[1],
          deplist: response.data.retData[2],
          batch: response.data.retData[3],
        });
        if (response.data.retData[4].length > 0) {
          this.setState((prevState) => ({
            tendername: response.data.retData[4][0].tendername,
            tendercode: response.data.retData[4][0].tendercode,
            tendertypeid: response.data.retData[4][0].tendertypeid,
            purchasetypeid: response.data.retData[4][0].purchasetypeid,
            departmentid: response.data.retData[4][0].departmentid,
            budget: response.data.retData[4][0].budget,
            evaluationdate: response.data.retData[4][0].evaluationdate,
            publishdate: response.data.retData[4][0].publishdate,
            startdate: response.data.retData[4][0].startdate,
            enddate: response.data.retData[4][0].enddate,
            plandate: response.data.retData[4][0].plandate,
            dkey: prevState.dkey + 1,
          }));
        }
      }
    });
  };

  handleInputChange(event) {
    const target = event.target;
    // const value = target.type === 'checkbox' ? target.checked : target.value;
    const value = target.value;
    const name = target.name;
    this.setState({
       [name]: value
    });
  }
  handleSelectChange(name, value) {
    this.setState({
       [name]: value
    });
  }
 
  onChangeBatchCode = (e, record) => {
    this.setState(
      this.state.batch.map((item) => {
        item.batchcode =
          item.batchname === record.batchname &&
          item.batchid === record.batchid &&
          item.key === record.key
            ? e.target.value
            : item.batchcode;
      })
    );
  };
  onChangeBatchName = (e, record) => {
    this.setState(
      this.state.batch.map((item) => {
        item.batchname =
          item.batchcode === record.batchcode &&
          item.batchid === record.batchid &&
          item.key === record.key
            ? e.target.value
            : item.batchname;
      })
    );
  };
  addBatch = () => {
    const newRow = {
      key: dynamickey,
      batchid: -1 - this.state.batch.length,
      batchcode: "",
      batchname: "",
      tenderid: this.state.tenderid,
    };
    this.setState({
      batch: [...this.state.batch, newRow],
    });
  };
  onSave = () => {
      if (
        this.state.tendername &&
        this.state.tendertypeid &&
        this.state.purchasetypeid &&
        this.state.publishdate &&
        this.state.departmentid && 
        this.state.evaluationdate &&
        this.state.startdate && 
        this.state.enddate &&
        this.state.plandate
      ) {
        let body = {
          tenderid: this.state.tenderid,
          tendercode: this.state.tendercode,
          tendername: this.state.tendername,
          tendertypeid: this.state.tendertypeid,
          purchasetypeid: this.state.purchasetypeid,
          departmentid: this.state.departmentid === null ? 0 : this.state.departmentid,
          budget: this.state.budget === null ? 0 : this.state.budget,
          evaluationdate: this.state.evaluationdate,
          publishdate: this.state.publishdate,
          startdate: this.state.startdate,
          enddate: this.state.enddate,
          plandate: this.state.plandate,
          createdby: this.context.username,
          batch: this.state.batch,
        };
        API.post("/saveTender", body).then((response) => {
          if (response.status === 200 && response.data.retType === 0) {
            message.success("Амжилттай хадгаллаа.");
            this.props.showForm(false, 0);
          }
        });
      }
  };
  handleDelete = (record) => {
    if (record.batchid !== 0) {
      this.setState({
        batch: this.state.batch.filter(function (param) {
          return param.batchid !== record.batchid;
        }),
      });
    } else {
      this.setState({
        batch: this.state.batch.filter(function (param) {
          return (
            param.batchcode !== record.batchcode &&
            param.batchname !== record.batchname
          );
        }),
      });
    }
  };
  render() {
    dynamickey++;
    const columns = [
      {
        title: "Багцын код",
        dataIndex: "batchcode",
        key: "batchcode",
        width: "50%",
        align: "left",
        render: (text, record) => {
          return (
            <Input
              size="large"
              disabled
              value={record.batchcode}
              placeholder="Багцын код оруулах"
            />
          );
        },
      },
      {
        title: "Багцын нэр",
        dataIndex: "batchname",
        key: "batchname",
        width: "50%",
        align: "left",
        render: (text, record) => {
          return (
            <Input
              size="large"
              value={record.batchname}
              onChange={(value) => this.onChangeBatchName(value, record)}
              placeholder="Багцын нэр оруулах"
            />
          );
        },
      },
      {
        title: " ",
        dataIndex: "operation",
        render: (_, record) => (
          <Popconfirm
            title="Устгахдаа итгэлтэй байна уу?"
            onConfirm={() => this.handleDelete(record)}
          >
            <DeleteOutlined style={{ color: "red" }} />
          </Popconfirm>
        ),
      },
    ];
    const { isEdit } = this.state;
    return (
      <div key={this.state.dkey} id="tender-add">
        <Form
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <div className="MidLabel" style={{ marginBottom: 15 }}>
            Ерөнхий мэдээлэл
          </div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Код"
                name="tendercode"
                initialvalue={this.state.tendercode}
              >
                <Input
                  style={{ height: 30 }}
                  size="large"
                  value={this.state.tendercode}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Нэр"
                name="tendername"
                initialvalue={this.state.tendername}
                rules={[
                  {
                    required: true,
                    message: "Тендерийн нэр оруулна уу.",
                  },
                ]}
              >
                <Input
                  style={{ height: 30 }}
                  disabled={isEdit ? false : true}
                  size="large"
                  initialValues= {this.state.tendername}
                  // defaultValue={this.state.tendername}
                  name = "tendername"
                  // onChange={(e) => this.onChangeTenderName(e.target.value)}
                  onChange={this.handleInputChange}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Төрөл"
                name="tendertypeid"
                initialvalue={this.state.tendertypeid}
                rules={[
                  {
                    required: true,
                    message: "Төрөл сонгоно уу.",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  disabled={isEdit ? false : true}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  name= "tendertypeid"
                  // onChange={this.onChangeType}
                  onChange={(e) => this.handleSelectChange("tendertypeid", e)}
                  defaultValue={this.state.tendertypeid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.tendertypelist &&
                    this.state.tendertypelist?.map((t, i) => (
                      <Select.Option key={i} value={t.tendertypeid}>
                        {t.tendertypename}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Худалдан авах ажиллагааны арга"
                name="purchasetypeid"
                initialvalue={this.state.purchasetypeid}
                rules={[
                  {
                    required: true,
                    message: "Худалдан авах арга сонгоно уу.",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  disabled={isEdit ? false : true}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  name="purchasetypeid"
                  // onChange={this.onChangePM}
                  onChange={(e) => this.handleSelectChange("purchasetypeid", e)}
                  defaultValue={this.state.purchasetypeid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.purchasetypelist &&
                    this.state.purchasetypelist?.map((t, i) => (
                      <Select.Option key={i} value={t.purchasetypeid}>
                        {t.purchasetypename}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Захиалагч"
                name="departmentid"
                initialvalue={this.state.departmentid}
                rules={[
                  {
                    required: true,
                    message: "Захиалагч сонгоно уу.",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  disabled={isEdit ? false : true}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  // onChange={this.onChangeDep}
                  name="departmentid"
                  onChange={(e) => this.handleSelectChange("departmentid", e)}
                  defaultValue={this.state.departmentid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.deplist &&
                    this.state.deplist?.map((t, i) => (
                      <Select.Option key={i} value={t.departmentid}>
                        {t.departmentname}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Төсөв"
                name="budget"
                initialvalue={this.state.budget}
              >
                <InputNumber
                  disabled={isEdit ? false : true}
                  placeholder="___._"
                  style={{ width: "100%" }}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  align="right"
                  defaultValue={this.state.budget}
                  name = "budget"
                  // onChange={(e) => this.onChangeTenderName(e.target.value)}
                  onChange={(e) => this.handleSelectChange("budget", e)}
                  // onChange={this.handleInputChange}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="MidLabel" style={{ marginBottom: 15 }}>
            Хугацаа
          </div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Үнэлгээний хороо байгуулах огноо"
                name="evaluationdate"
                initialvalue={
                  this.state.evaluationdate
                    ? moment(this.state.evaluationdate, dateFormat)
                    : null
                }
                rules={[
                  {
                    required: true,
                    message: "Огноо оруулна уу.",
                  },
                ]}
              >
                <DatePicker
                  defaultValue={
                    this.state.evaluationdate
                      ? moment(this.state.evaluationdate, dateFormat)
                      : null
                  }
                  disabled={isEdit ? false : true}
                  // onChange={this.onChangeEvalutionDate}
                  name="evaluationdate"
                  onChange={(e) => this.handleSelectChange("evaluationdate", e)}
                  format={dateFormat}
                  style={{ width: "100%", height: 30 }}
                  placeholder=""
                ></DatePicker>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Тендерийн урилга нийтлэх огноо"
                name="publishdate"
                initialvalue={
                  this.state.publishdate
                    ? moment(this.state.publishdate, dateFormat)
                    : null
                }
                rules={[
                  {
                    required: true,
                    message: "Огноо оруулна уу.",
                  },
                ]}
              >
                <DatePicker
                  defaultValue={
                    this.state.publishdate
                      ? moment(this.state.publishdate, dateFormat)
                      : null
                  }
                  disabled={isEdit ? false : true}
                  // onChange={this.onChangePublishDate}
                  name="publishdate"
                  onChange={(e) => this.handleSelectChange("publishdate", e)}
                  format={dateFormat}
                  style={{ width: "100%", height: 30 }}
                  placeholder=""
                ></DatePicker>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Гэрээ байгуулах эрх олгох огноо"
                name="startdate"
                initialvalue={
                  this.state.startdate
                    ? moment(this.state.startdate, dateFormat)
                    : null
                }
                rules={[
                  {
                    required: true,
                    message: "Огноо оруулна уу.",
                  },
                ]}
              >
                <DatePicker
                  disabled={isEdit ? false : true}
                  defaultValue={
                    this.state.startdate
                      ? moment(this.state.startdate, dateFormat)
                      : null
                  }
                  // onChange={this.onChangeStartDate}
                  name="startdate"
                  onChange={(e) => this.handleSelectChange("startdate", e)}
                  format={dateFormat}
                  style={{ width: "100%", height: 30 }}
                  placeholder=""
                ></DatePicker>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Гэрээ дуусгавар болох, дүгнэх огноо"
                name="enddate"
                initialvalue={
                  this.state.enddate
                    ? moment(this.state.enddate, dateFormat)
                    : null
                }
                rules={[
                  {
                    required: true,
                    message: "Огноо оруулна уу.",
                  },
                ]}
              >
                <DatePicker
                  disabled={isEdit ? false : true}
                  defaultValue={
                    this.state.enddate
                      ? moment(this.state.enddate, dateFormat)
                      : null
                  }
                  name="enddate"
                  onChange={(e) => this.handleSelectChange("enddate", e)}
                  // onChange={this.onChangeEndDate}
                  format={dateFormat}
                  style={{ width: "100%", height: 30 }}
                  placeholder=""
                ></DatePicker>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 600 }}
                label="Төлөвлөсөн хугацаа"
                name="plandate"
                initialvalue={
                  this.state.plandate
                    ? moment(this.state.plandate, dateFormat)
                    : null
                }
                rules={[
                  {
                    required: true,
                    message: "Огноо оруулна уу.",
                  },
                ]}
              >
                <DatePicker
                  disabled={isEdit ? false : true}
                  defaultValue={
                    this.state.plandate
                      ? moment(this.state.plandate, dateFormat)
                      : null
                  }
                  name="plandate"
                  // onChange={this.handleInputChange}
                  onChange={(e) => this.handleSelectChange("plandate", e)}
                  format={dateFormat}
                  style={{ width: "100%", height: 30 }}
                  placeholder=""
                ></DatePicker>
              </Form.Item>
            </Col>
          </Row>
          <Row justify="start" align="middle">
            <Col>
              <div className="MidLabel" style={{ marginBottom: 15 }}>
                Багц
              </div>
            </Col>
            <Col>
              {isEdit ?
              <Button
                style={{ marginLeft: 50, marginBottom: 10 }}
                type="link"
                onClick={this.addBatch}
              >
                Багц нэмэх
              </Button>
              : null}
            </Col>
          </Row>
            <Table
            dataSource={this.state.batch}
            columns={columns}
            pagination={false}
            rowKey="batchid"
            />
          <Form.Item label=" ">
            <Button
              disabled={isEdit ? false : true}
              type="primary"
              className="btnPrimary"
              htmlType="submit"
              onClick={this.onSave}
            >
              Тендер хадгалах
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default TenderAdd;
